import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import APIS from '../../../constant/Endpoint';
import Button from '../../Reusable/Button';
import ComboboxInput from '../../Reusable/ComboboxInput';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import StatusComboboxInput from '../../Reusable/StatusCombobox';
let assignToRiderValidationForm = yup.object().shape({
  rider_id: yup.string().required('Rider is required'),
  status_id: yup.string().required('Next Status is required'),
});
const AssignToRider = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    resolver: yupResolver(assignToRiderValidationForm),
  });

  return (
    <div className={tw`flex flex-col justify-between min-h-full`}>
      <StatusComboboxInput
        url={`${APIS.RUNSHEET_SETTING}`}
        queryKey={'rider-status'}
        register={register('status_id')}
        errors={errors?.status_id}
        name={'status_id'}
        label={'Next Status'}
        setValue={setValue}
        props={{
          status: 'intermediate',
          is_active: true,
        }}
        placeholder={'Choose next Status'}
        getValues={getValues}
        clearErrors={clearErrors}
        watch={watch}
      />
      <ComboboxInput
        url={APIS.RIDER}
        queryKey={'rider'}
        register={register('rider_id')}
        errors={errors?.rider_id}
        name={'rider_id'}
        label={'Rider'}
        setValue={setValue}
        props={{
          is_active: true,
        }}
        placeholder={'Search Rider'}
        getValues={getValues}
        clearErrors={clearErrors}
        watch={watch}
      />
      <div className={tw`w-[100px] mr-4 absolute bottom-4 right-2`}>
        <Button
          label={'Submit'}
          onClick={handleSubmit((data: any) =>
            props?.handleActionMenu(data, 'Assign To Rider', setError)
          )}
        />
      </div>
    </div>
  );
};

export default AssignToRider;
